
export enum ResultBehaviour {
    default = 1,
    noGroup,
    noGroupSimple,
}
